/**
 * Verificar si es el dominio de producción
 * @returns boolean
 */
export function isProductionDomain() : boolean {
  return window.location.host.includes("laspuertasdemazatlan.com");
}